import { useMemo } from 'react';
import {
  buildCumulativePointsFromCounts,
  buildDiscoverySeries,
  filterDiscoveryCounts,
  inferFirstDiscoveryYear,
} from '../series/discoverySeries';

export const useDiscoverySeries = ({ filteredRecords, startYear, endYear }) => {
  const { chartData, currentCount, discoveryCounts } = useMemo(() => (
    buildDiscoverySeries(filteredRecords, startYear, endYear)
  ), [filteredRecords, startYear, endYear]);

  const modelStartYear = useMemo(() => (
    inferFirstDiscoveryYear(discoveryCounts) ?? startYear
  ), [discoveryCounts, startYear]);

  const modelDiscoveryCounts = useMemo(() => (
    filterDiscoveryCounts(discoveryCounts, modelStartYear)
  ), [discoveryCounts, modelStartYear]);

  const modelFitPoints = useMemo(() => (
    buildCumulativePointsFromCounts(modelDiscoveryCounts, modelStartYear)
  ), [modelDiscoveryCounts, modelStartYear]);

  const modelSolowPoints = useMemo(() => (
    modelFitPoints.map(point => ({ x: point.year, y: point.y }))
  ), [modelFitPoints]);

  return {
    chartData,
    currentCount,
    discoveryCounts,
    modelStartYear,
    modelDiscoveryCounts,
    modelFitPoints,
    modelSolowPoints,
  };
};
